import { __assign } from "tslib";
import { omitBy } from 'lodash';
import React from 'react';
import { useRemainingWidth, WidthProvider } from '../width-context';
export function ColumnItem(props) {
    var align = props.align, containerBackgroundColor = props.containerBackgroundColor, cssClass = props.cssClass, padding = props.padding, paddingBottom = props.paddingBottom, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, paddingTop = props.paddingTop, verticalAlign = props.verticalAlign;
    var remainingWidth = useRemainingWidth({
        padding: padding,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
    });
    // NOTE: client side and server side react style attribute merging behaves differently.
    // So to make it 1:1 in both cases if property doesn't exist we don't need to set it.
    var paddings = omitBy({
        padding: padding,
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft,
    }, function (value) { return !value; });
    return (React.createElement("tr", null,
        React.createElement("td", { align: align, valign: verticalAlign, className: cssClass, style: __assign(__assign({ background: containerBackgroundColor, fontSize: '0px' }, paddings), { wordBreak: 'break-word' }) },
            React.createElement(WidthProvider, { value: remainingWidth }, props.children))));
}
//# sourceMappingURL=column-item.js.map